// Gedeelde invoer- en knopstijl van de beheervlakken. Stond onderaan het oude
// BeheerPagina.tsx; sinds W6 (acht vlakken, besluit V1) delen Wachtrij en
// Gebruikers hem, en de vlakken van de volgende rondes erven hem. Bewust geen
// gedeeld ui-component: het is een handvol stijlen, geen gedrag.

import type { CSSProperties } from "react";

import { color, radius, size, weight } from "../../tokens";

export const invoer: CSSProperties = {
  width: "100%",
  boxSizing: "border-box",
  padding: "9px 11px",
  fontSize: size.body,
  fontFamily: "inherit",
  color: color.ink,
  background: color.surface,
  border: `1px solid ${color.border}`,
  borderRadius: radius.input,
  outline: "none",
};

export const knopLicht: CSSProperties = {
  background: "none",
  border: `1px solid ${color.border}`,
  color: color.body,
  borderRadius: radius.input,
  padding: "8px 14px",
  fontSize: size.meta,
  fontFamily: "inherit",
  cursor: "pointer",
  whiteSpace: "nowrap",
};

export function knopDonker(bezig: boolean): CSSProperties {
  return {
    background: bezig ? color.disabled : color.ink,
    border: "none",
    color: color.surface,
    borderRadius: radius.input,
    padding: "8px 14px",
    fontSize: size.meta,
    fontWeight: weight.medium,
    fontFamily: "inherit",
    cursor: bezig ? "default" : "pointer",
    whiteSpace: "nowrap",
  };
}
